import React from 'react'
import { alpha, Box, Typography, ButtonBase } from '@mui/material'
import RowStack from 'components/atoms/container/RowStack'
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined'
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined'
import SourceOutlinedIcon from '@mui/icons-material/SourceOutlined'
import RadarOutlinedIcon from '@mui/icons-material/RadarOutlined'
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined'
import PsychologyAltOutlinedIcon from '@mui/icons-material/PsychologyAltOutlined'
import BookmarkButton from 'components/atoms/button/BookmarkButton'
import { JOURNEY_STEPS_SECTIONS } from 'services/constants'
import colors from 'styles/colors'
import { useTranslation } from 'react-i18next'

const StepPathObjectHeader = ({
  l1StepName,
  stepData,
  stepType,
  navBtns,
  scrollToSection,
  showBookmark = true
}) => {
  const { t } = useTranslation()
  const NavTab = ({ tab, icon, tabId, ...containerProps }) => {
    return (
      <ButtonBase onClick={() => scrollToSection(tabId)}>
        <RowStack spacing={2} padding={4} width={'auto'} {...containerProps}>
          {React.cloneElement(icon, {
            sx: { color: colors.MidnightTeal400 }
          })}
          <Typography variant='h5' color={colors.MidnightTeal400}>
            {tab}
          </Typography>
        </RowStack>
      </ButtonBase>
    )
  }

  const NavButton = ({ tab, icon, tabId, borderColor, bgColor }) => {
    return (
      <NavTab
        tab={tab}
        icon={icon}
        tabId={tabId}
        sx={{
          borderRadius: 2,
          border: `1px solid ${borderColor}`,
          backgroundColor: bgColor
        }}
      />
    )
  }

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        backgroundColor: colors.White,
        zIndex: 4
      }}>
      <RowStack
        paddingBottom={4}
        justifyContent='space-between'
        borderBottom={stepType==='content' && `1px solid ${colors.Grey100}`}>
        <RowStack spacing={4}>
          {stepType === 'content' ? (
            <Typography variant='h2' color={colors.MidnightTeal400}>
              {stepData?.title}
            </Typography>
          ) : (
            <>
              <PsychologyAltOutlinedIcon
                sx={{ color: colors.MidnightTeal400, fontSize: 40 }}
              />
              <Typography variant='h2' color={colors.MidnightTeal400}>
                {stepData?.title
                  ? stepData?.title
                  : `${t('pathsAndModels.learningCheck')}: ${l1StepName}`}
              </Typography>
            </>
          )}
        </RowStack>

        {navBtns}
      </RowStack>

      {stepType === 'content' && (
        <>
          <RowStack
            paddingY={3}
            justifyContent='space-between'
            borderBottom={`1px solid ${colors.Grey100}`}>
            <RowStack spacing={8} width={'auto'}>
              {(stepData.contentWeb || stepData.summary) && (
                <NavTab
                  tab={t('pathsAndModels.content')}
                  icon={<TextSnippetOutlinedIcon />}
                  tabId={JOURNEY_STEPS_SECTIONS.CONTENT}
                />
              )}
              <NavTab
                tab={t('common.notes')}
                icon={<StickyNote2OutlinedIcon />}
                tabId={JOURNEY_STEPS_SECTIONS.NOTES}
              />
              {stepData.sources && (
                <NavTab
                  tab={t('stepNote.sources')}
                  icon={<SourceOutlinedIcon />}
                  tabId={JOURNEY_STEPS_SECTIONS.SOURCES}
                />
              )}
            </RowStack>

            <RowStack spacing={4} width={'auto'}>
              {stepData.goalQuestion && (
                <NavButton
                  tab={t('stepNote.setGoal')}
                  icon={<RadarOutlinedIcon />}
                  borderColor={colors.GoldenYellow100}
                  bgColor={colors.GoldenYellow50}
                  tabId={JOURNEY_STEPS_SECTIONS.GOAL}
                />
              )}

              {stepData.activityQuestion && (
                <NavButton
                  tab={t('stepNote.activity')}
                  icon={<ArticleOutlinedIcon />}
                  borderColor={alpha(colors.Peach400, 0.5)}
                  bgColor={colors.Peach50}
                  tabId={JOURNEY_STEPS_SECTIONS.ACTIVITY}
                />
              )}
            </RowStack>
          </RowStack>

          {showBookmark && (
            <BookmarkButton
              stepContentId={stepData?.id}
              bookmarked={stepData?.bookmarked}
            />
          )}
        </>
      )}
    </Box>
  )
}
export default StepPathObjectHeader
